// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular.module('landingPage').directive('giVideoPreview', ($q) => ({
  scope: {},

  link(scope, element, attributes) {
    // The timing of loading, playing, and pausing video is important
    // to get right without error. These properties will help us.
    scope.videoState = 'not-loaded';
    scope.intent = null;

    // `img` and `video` child elements need to exist; giVideoPreview will use pre-existing ones if you provide them
    scope.posterElement = element.find('img');
    if (scope.posterElement.length === 0) {
      scope.posterElement = element.append(
        `<img class='gi-video-preview__poster' src='${attributes.poster}' />`
      );
    }

    scope.videoElement = element.find('video');
    if (scope.videoElement.length === 0) {
      scope.videoElement = scope.posterElement.after(
        `<video class='gi-video-preview__video' poster='${attributes.poster}' />`
      );
    }

    scope.playVideo = function () {
      scope.intent = 'play';

      // Load the video if it's not already loaded
      if (!scope.videoElement.attr('src')) {
        scope.videoState = 'loading';
        element.addClass('is-loaded');
        scope.videoElement.attr('src', attributes.videoSrc);
      }

      if (scope.videoState !== 'playing') {
        // HTMLMediaelement.play() may return a promise or null, depending on the browser version
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play#Browser_compatibility
        // If it returns null, create our own resolved Promise so we can use the same app logic to handle it.
        //
        // Note that, at least in Chrome, the HTMLMediaElement "play" event is *not* as reliable as the promise
        // resolution when it comes to determining when the video is actually playing (and thus can be paused
        // without error).
        const playPromise =
          scope.videoElement[0].play() || scope.fakeAVideoPlayPromise();
        playPromise.then(function () {
          scope.videoState = 'playing';
          element.addClass('is-playing');
          element.removeClass('is-paused');
          // Pauses (ex: from mouseleave) can happen before the video starts playing (since it takes a while
          // to load the content). Pause the video if this happens.
          if (scope.intent === 'pause') {
            return scope.pauseVideo();
          }
        });
        return playPromise.catch((error) =>
          console.error('Error playing video', attributes.videoSrc, error)
        );
      }
    };

    scope.fakeAVideoPlayPromise = () =>
      // If we don't have a video play promise from the browser, we'll need
      // to watch the events to see when/if it starts
      $q(function (resolve, reject) {
        scope.videoElement.one('play', () => resolve());
        return scope.videoElement.one('error', (event) => reject(event.error));
      });

    scope.pauseVideo = function () {
      scope.intent = 'pause';
      if (scope.videoState === 'playing') {
        // Chrome (at least) throws an error if you pause a video before it starts playing
        scope.videoElement[0].pause();
      }
      element.removeClass('is-playing');
      return element.addClass('is-paused');
    };

    element.on('mouseenter', () => scope.playVideo());

    element.on('mouseleave', () => scope.pauseVideo());

    scope.videoElement.on('ended', () => (scope.videoState = 'ended'));

    return scope.videoElement.on('pause', () => (scope.videoState = 'paused'));
  },
}));
